// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkuCard_sku-card__NsJ-p {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.SkuCard_sku-card__details-container__8MhMr {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}

.SkuCard_sku-card__image-container__TXiOW {
  border: 0.1rem solid var(--black-ten-opacity);
  border-radius: 1rem;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25rem;
}

.SkuCard_sku-card__image-container__TXiOW:hover {
  box-shadow: 0px 4px 14px 0px var(--black-15-opacity);
}

.SkuCard_sku-card__image__0I13l {
  max-height: 100%;
  object-fit: contain;
}

.SkuCard_sku-card__details__bHNXe {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.SkuCard_sku-card__brand-name__4tmvE {
  color: var(--gray-dark);
  font-size: var(--text-base);
  font-weight: 500;
}

.SkuCard_sku-card__name__Y6B2u {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
  margin-bottom: 1rem;
}

.SkuCard_sku-card__footer__CKnBl {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.SkuCard_sku-card__price-wrapper__U69hE {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.SkuCard_sku-card__price__iI3in {
  color: var(--primary-color);
  font-size: var(--text-lg);
  font-weight: 700;
}

.SkuCard_sku-card__price-currency__wqJo1 {
  font-size: var(--text-sm);
}

.SkuCard_sku-card__bundle-offer__3YoM0 {
  align-self: flex-start;
  background-color: var(--sky);
  color: var(--primary-color);
  border: 0.1rem solid var(--primary-color);
  border-radius: 0.4rem;
  padding: 0.4rem;
  font-size: var(--text-xs);
  font-weight: 700;
}

.SkuCard_sku-card__bundle-offer__3YoM0:hover {
  text-decoration: underline;
}

.SkuCard_sku-card__add-to-cart-btn__dzgXK {
  padding-block: 1.5rem;
  justify-content: center;
}

.SkuCard_sku-card__quantity-wrapper__B0\\+Uq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.SkuCard_sku-card__quantity-controls__Y9c9x {
  flex-grow: 1;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .SkuCard_sku-card__quantity-wrapper__B0\\+Uq {
    gap: 4rem;
  }

  .SkuCard_sku-card__added-to-cart__lAw4e p {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SkuCard/SkuCard.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".sku-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.sku-card__details-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n}\n\n.sku-card__image-container {\n  border: 0.1rem solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 25rem;\n}\n\n.sku-card__image-container:hover {\n  box-shadow: 0px 4px 14px 0px var(--black-15-opacity);\n}\n\n.sku-card__image {\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.sku-card__details {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.sku-card__brand-name {\n  color: var(--gray-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.sku-card__name {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n\n.sku-card__footer {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.sku-card__price-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sku-card__price {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  font-weight: 700;\n}\n\n.sku-card__price-currency {\n  font-size: var(--text-sm);\n}\n\n.sku-card__bundle-offer {\n  align-self: flex-start;\n  background-color: var(--sky);\n  color: var(--primary-color);\n  border: 0.1rem solid var(--primary-color);\n  border-radius: 0.4rem;\n  padding: 0.4rem;\n  font-size: var(--text-xs);\n  font-weight: 700;\n}\n\n.sku-card__bundle-offer:hover {\n  text-decoration: underline;\n}\n\n.sku-card__add-to-cart-btn {\n  padding-block: 1.5rem;\n  justify-content: center;\n}\n\n.sku-card__quantity-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.sku-card__quantity-controls {\n  flex-grow: 1;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .sku-card__quantity-wrapper {\n    gap: 4rem;\n  }\n\n  .sku-card__added-to-cart p {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sku-card": `SkuCard_sku-card__NsJ-p`,
	"sku-card__details-container": `SkuCard_sku-card__details-container__8MhMr`,
	"sku-card__image-container": `SkuCard_sku-card__image-container__TXiOW`,
	"sku-card__image": `SkuCard_sku-card__image__0I13l`,
	"sku-card__details": `SkuCard_sku-card__details__bHNXe`,
	"sku-card__brand-name": `SkuCard_sku-card__brand-name__4tmvE`,
	"sku-card__name": `SkuCard_sku-card__name__Y6B2u`,
	"sku-card__footer": `SkuCard_sku-card__footer__CKnBl`,
	"sku-card__price-wrapper": `SkuCard_sku-card__price-wrapper__U69hE`,
	"sku-card__price": `SkuCard_sku-card__price__iI3in`,
	"sku-card__price-currency": `SkuCard_sku-card__price-currency__wqJo1`,
	"sku-card__bundle-offer": `SkuCard_sku-card__bundle-offer__3YoM0`,
	"sku-card__add-to-cart-btn": `SkuCard_sku-card__add-to-cart-btn__dzgXK`,
	"sku-card__quantity-wrapper": `SkuCard_sku-card__quantity-wrapper__B0+Uq`,
	"sku-card__quantity-controls": `SkuCard_sku-card__quantity-controls__Y9c9x`,
	"sku-card__added-to-cart": `SkuCard_sku-card__added-to-cart__lAw4e`
};
export default ___CSS_LOADER_EXPORT___;
